export const TRADE_AUTH_REQUIRED_EVENT = 'wt:trade-auth-required'

type IdentityWaiter = { resolve: (ok: boolean) => void }

let identityWaiter: IdentityWaiter | null = null

export function requestTradeAuthentication(): void {
  // Trading never asks for a confirm-it's-you step. A live session is the
  // authorization. Seed reveal uses requestIdentityConfirmation instead.
}

export function requestIdentityConfirmation(): Promise<boolean> {
  identityWaiter?.resolve(false)
  return new Promise((resolve) => {
    identityWaiter = { resolve }
    window.dispatchEvent(new Event(TRADE_AUTH_REQUIRED_EVENT))
  })
}

export function completeIdentityConfirmation(ok: boolean): void {
  identityWaiter?.resolve(ok)
  identityWaiter = null
}

export function hasPendingIdentityConfirmation(): boolean {
  return identityWaiter !== null
}

export function isAccountAuthCopy(message: string): boolean {
  return /confirm your account/i.test(message)
}
